import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';

interface ProfileSectionProps {
  profileImage: string;
  profileImageAlt: string;
  name: string;
}

const ProfileSection = ({ profileImage, profileImageAlt, name }: ProfileSectionProps) => {
  return (
    <motion.div
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className="relative mb-8"
    >
      <div className="relative w-48 h-48 mx-auto">
        <div className="absolute inset-0 rounded-full bg-gradient-cta opacity-20 blur-2xl animate-pulse" />
        <div className="relative w-full h-full rounded-full overflow-hidden border-4 border-accent shadow-brand-lg">
          <Image
            src={profileImage}
            alt={profileImageAlt}
            className="w-full h-full object-cover"
            loading="eager"
          />
        </div>
      </div>
    </motion.div>
  );
};

export default ProfileSection;